import { BellSchedulesDTO } from '../bell-schedule/models/bell-schedule.model';


export class ScheduleFolderDTO {
    Selected: boolean;
    ID: number;
    Site_ID: number;
    Year_ID: number;
    Name: string;
    Type: number;
    AddedMethod: string;
    IsDefault: boolean;
    SourceSchedulingFolders_ID: number;
    AddedBy: number;
    AddedOn: Date;
    LastUpdatedBy: number;
    LastUpdatedOn: Date;
    SchoolName: string;
    BellSchedules: BellSchedulesDTO[];

    // Local Properties
    get typeName() {
        switch (this.Type) {
            case 1:
                return (this.IsDefault ? 'Default ' : '') + 'Plan';
            case 2:
                return 'Source';
            case 3:
                return 'Active';
        }
    }
}

export class ScheduleFolderDetails extends ScheduleFolderDTO{

    // Server Properties
    ScheduleFolders_ID: number;
    ScheduleFoldersName: string;
    MeetingPatterns: number;
    Classes_Total: number;
    Classes_NoTeacher: number;
    Classes_NoRoom: number;
    Classes_NoMeetingPattern: number;
    Classes_NoTerm: number;
    Teacehrs_Total: number;
    Teacehrs_NoSchedule: number;
    Teacehrs_PartiallySchedule: number;
    Teacehrs_FullySchedule: number;
    Teacehrs_AverageUtilization: number;
    Rooms_Total: number;
    Rooms_NoSchedule: number;
    Rooms_PartiallySchedule: number;
    Rooms_FullySchedule: number;
    Rooms_AverageUtilization: number;
    ScheduleFolderGradeLevels: ScheduleFolderGradeLevelsDTO[];

    // Local Properties
    get nameAndStatus(): string {
        return this.typeName + ' - ' + this.ScheduleFoldersName;
    }
}
export class ScheduleFolderGradeLevelsDTO {
    ScheduleFolders_ID: number;
    GradeLevel: string;
    Total: number;
    NoSchedule: number;
    PartiallySchedule: number;
    FullySchedule: number;
    AverageUtilization: number;
}
export class SFCards {
    Card1: ScheduleFolderDetails;
    Card2: ScheduleFolderDetails;
}
